
import styles from './companyHistorySection.module.css';
import { List } from '../../../ui/list/List';
import { listItems } from '../../../../constants/aboutUsPage/listItems';

export function CompanyHistorySection() {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.infoContainer}>
        <div className={styles.header}>история компании</div>
        <div className={styles.textContainer}>
          <p>
            Компания Sudheimer Car Technik - Vertriebs GmbH расположена в городе Ведель – пригороде Гамбурга, северная Германия.  Своей целью мы ставим предоставление в кратчайшие сроки и по доступным ценам нашим международным партнерам полного ассортимента высококачественной продукции для эксплуатации автотранспорта. Компания Sudheimer Car Technik - Vertriebs GmbH производит продукцию под торговыми марками SCT-GERMANY и MANNOL и распространяет через разветвленную сеть в 120 странах на пяти континентах. В подавляющем большинстве стран мы являемся бесспорным лидером продаж импортируемых товаров рынка автомобильных запасных частей.
            Удовлетворяющий самые взыскательные запросы ассортимент предлагаемых товаров Sudheimer Car Technik - Vertriebs GmbH включает в себя более 3000 наименований запчастей SCT-GERMANY, постоянно имеющихся на складах, для наиболее популярных моделей автомобилей. Смазочные материалы и рабочие жидкости под торговой маркой MANNOL, предлагаемые по конкурентоспособным ценам, представляют широчайший спектр продуктов собственного производства по уходу за автомобилем.
            Философия и цель Компании Sudheimer Car Technik - Vertriebs GmbH заключается в максимально полном удовлетворении пожеланий наших партнеров и ориентировании на постоянный и неуклонный рост их запросов и потребностей. Стратегическими преимуществами сотрудничества с Sudheimer Car Technik - Vertriebs GmbH являются беспрецедентные возможности совмещения минимизации координационных и транспортных расходов и широчайшего ассортимента предлагаемой продукции.
            Для развития новых рынка сбыта компания Sudheimer Car Technik - Vertriebs GmbH приглашает к сотрудничеству. Мы гарантируем, что все предложения будут тщательно изучены и всесторонне рассмотрены.


          </p>
          <p>  Наша цель – ваш успех!</p>
          <List listItems={listItems} />
        </div>
      </div>
      <div>
        <img
          className={styles.image}
          src="/images/aboutUsPage/au.jpg"
          alt="Офис SCT"
        />
      </div>
    </div>
  );
}
